<template>
  <Error
    title="ログインが成功しました"
    lead="当サービスはPhorbsから開く必要があります"
    :top-link="false"
  >
    <template #default>
      現在のタブを閉じて、Phorbsから操作を続けてください。
    </template>
  </Error>
</template>

<script>
import Error from '@/components/Error.vue'

export default {
  navbar: false,
  components: {
    Error
  },
  metaInfo() {
    return {
      title: 'ログインが成功しました',
      bodyAttrs: { class: 'error' }
    }
  }
}
</script>
